import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { bindActionCreators } from 'redux';

import feSetBookingStartTime from 'actions/booking/feSetBookingStartTime.action';
import RRPT from 'constants/recurrence/recurrenceRuleParseType.const';
import recurrenceFirstRule from 'utils/recurrence/recurrenceFirstRule.util';
import recurrenceRuleSimplified from 'utils/recurrence/recurrenceRuleSimplified.util';

import { getEvent, setAllDay, setEndTime, setRepeatForever, setRepeatingRule, setType } from 'booking/actions';
import HeaderWrapper from 'booking/components/common/bw-header/HeaderWrapper';
import BWContent from 'booking/components/common/BWContent';
import CloseButton from 'booking/components/common/CloseButton';
import { closeUrl } from 'booking/utils';

class EventLoading extends React.Component {
  constructor(props) {
    super(props);
    this.state = { requested: false, isWeekView: false };
  }

  // noinspection JSDeprecatedSymbols
  UNSAFE_componentWillMount() {
    const pathArray = this.props.location.pathname.split('/');
    let eventId = parseInt(pathArray[7], 10);
    if (this.props.location.pathname.includes('/week/')) {
      this.setState({ isWeekView: true });
      eventId = parseInt(pathArray[8], 10);
    }
    this.props.getEvent(this.props.salonId, eventId);
    this.setState({ requested: true });
  }

  // noinspection JSDeprecatedSymbols,JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { pathname } = nextProps.location;
    const pathArray = pathname.split('/');
    let eventId = parseInt(pathArray[7], 10);
    if (this.state.isWeekView) {
      eventId = parseInt(pathArray[8], 10);
    }

    if (
      this.state.requested &&
      !nextProps.fetchEvent.isFetching &&
      nextProps.fetchEvent.response &&
      nextProps.fetchEvent.response.id === eventId
    ) {
      const allDay =
        moment(nextProps.fetchEvent.response.end_time).diff(
          moment(nextProps.fetchEvent.response.start_time),
          'minutes',
        ) >
        60 * 11;

      if (allDay) {
        this.props.setAllDay();
      }

      const { recurrences } = nextProps.fetchEvent.response;

      if (recurrences) {
        const firstRule = recurrenceFirstRule({ string: recurrences, type: RRPT.mm });

        if (firstRule.until || firstRule.options.until) {
          const until = firstRule.until ? firstRule.until : firstRule.options.until.toISOString();
          const endDate = moment(until);
          this.props.setRepeatForever(false, endDate);
        } else {
          this.props.setRepeatForever(true, null);
        }
      }

      this.props.setRepeatingRule(recurrenceRuleSimplified({ string: recurrences, type: RRPT.mm }));
      this.props.feSetBookingStartTime(moment(nextProps.fetchEvent.response.start_time));
      this.props.setEndTime(moment(nextProps.fetchEvent.response.end_time));

      let path = `/salon/${nextProps.salonId}/day/${pathArray[4]}/event/edit/${
        nextProps.fetchEvent.response.id
      }/timeoff`;

      if (this.state.isWeekView) {
        if (this.props.location.pathname.includes('/week/')) {
          path = `/salon/${nextProps.salonId}/week/${pathArray[4]}/${pathArray[5]}/event/edit/${
            nextProps.fetchEvent.response.id
          }/timeoff`;
        }
      }
      nextProps.history.replace(path);
    }
  }

  render() {
    return (
      <div data-bem="EventLoading">
        <div data-bem="EventLoading--booking-window" className="BookingWindow">
          <HeaderWrapper>
            <CloseButton history={this.props.history} close={closeUrl(this.props.location)} />
          </HeaderWrapper>
          <BWContent>
            <div data-bem="EventLoading__loading-indicator" className="booking-loading">
              <div className="loading-wrap">
                <div className="loading-anim">
                  <div className="loading-title">
                    <span>Loading Salon Data</span>
                  </div>
                </div>
                <div className="loading-feedback">
                  {' '}
                  {this.props.fetchEvent.isFetching ? 'Booking appointment' : 'Getting event data'}
                </div>
              </div>
            </div>
          </BWContent>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { getEvent, feSetBookingStartTime, setEndTime, setType, setAllDay, setRepeatingRule, setRepeatForever },
    dispatch,
  );

const mapStateToProps = (state) => ({
  fetchEvent: state.booking.fetchEvent,
  salonId: state.currentSalon.id,
});

const EventLoadingHoc = connect(
  mapStateToProps,
  mapDispatchToProps,
)(EventLoading);

export default EventLoadingHoc;
